import UserSelectProvider from 'components/CIMSSelect/common/UserSelect/UserSelectContext'
import { TypesTable } from './components/TypesTable'
import { TypesTableProvider } from './TypesTableContext'

const EJTypes: React.FC = () => (
  <TypesTableProvider>
    <UserSelectProvider>
      <TypesTable />
    </UserSelectProvider>
  </TypesTableProvider>
)

export default EJTypes
